import React from 'react';
import '../../styles/Table.css';

const Table = ({ columns, data }) => {
    return (
        <div className="ui-table-container">
            <table className="ui-table">
                <thead>
                    <tr>
                        {columns.map((col, index) => (
                            <th key={index}>{col.header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length} className="empty-state">No hay datos para mostrar.</td>
                        </tr>
                    ) : (
                        data.map((item, rowIndex) => (
                            <tr key={item.id || rowIndex}>
                                {columns.map((col, colIndex) => (
                                    <td key={colIndex} data-label={col.header}>{col.accessor(item)}</td>
                                ))}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default Table;